import React from 'react'
import { useClientOnly } from '@hooks/useClientOnly';

interface ClientOnlyProps {
  Component: React.LazyExoticComponent<React.ComponentType<any>>
  fallback?: React.ReactNode
}

function ClientOnly<T,>({ Component, fallback, ...rest }: T & ClientOnlyProps) {
  const isClient = useClientOnly();

  return (
    <React.Suspense fallback={fallback}>
      {isClient && <Component {...rest} />}
    </React.Suspense>
  )
}

export default ClientOnly